import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_one, fetch_all } from "../../lib/v31lib";
// import { loginAtom } from '../../lib/auth';
import { currentPracticeAtom } from '../../lib/practice';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';

import {
  Box,
  Divider,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Page,
  // Typography
} from '../../components/v2/styled';
import { RestrictedSettingsAccount } from './settings/Account';
import { RestrictedSettingsEhealth } from './settings/Ehealth';
import { RestrictedSettingsNutriMail } from './settings/NutriMail';
import { RestrictedSettingsPractice } from './settings/Practice';
import { RestrictedSettingsSecurity } from './settings/Security';
import { RestrictedSettingsZorgMail } from './settings/ZorgMail';
import HelpersPractice from '../../actions/helpers/practice';
import { FEATURES } from '../../features';

// const { DateTime } = require("luxon");

type Props = {}

export const RestrictedSettings: FunctionComponent<Props> = ({}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  const { state } = useLocation();

  const [currentTab, setCurrentTab] = useState<number>(!!state && !!state.tab ? state.tab : 0);

  const is_zorg_mail = HelpersPractice.practice_modules_v3({ practice: currentPractice, check: 'zorg_mail' });

  return <Page>
    <Box>
      <Box sx={{
        marginBottom: 3,
        '& .Mui-selected': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }
      }}>
        <Tabs
          value={currentTab}
          onChange={(e, v) => {setCurrentTab(v);}}
          indicatorColor="primary"
          textColor="primary"
          aria-label="Filters"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab icon={<AccountCircleIcon />} label={t("client.settings.account.title")} />
          <Tab icon={<BusinessIcon />} label={t("restricted.settings.practice.title")} />
          <Tab icon={<EmailIcon />} label={t("client.settings.nutri_mail.title")} />
          <Tab icon={<LockIcon />} label={t("client.personal_settings.security.title")} />
          <Tab icon={<LockIcon />} label={t("restricted.personal_settings.ehealth.title")} />
          {!!is_zorg_mail && FEATURES.ENABLE_ZORGMAIL && <Tab icon={<LockIcon />} label={t("restricted.personal_settings.zorgmail.title", "ZorgMail")} />}
        </Tabs>
        <Divider sx={{borderColor: theme.palette.primary.main}} />
      </Box>


      {currentTab === 0 && <RestrictedSettingsAccount />}
      {currentTab === 1 && <RestrictedSettingsPractice />}
      {currentTab === 2 && <RestrictedSettingsNutriMail />}
      {currentTab === 3 && <RestrictedSettingsSecurity />}
      {currentTab === 4 && <RestrictedSettingsEhealth />}
      {currentTab === 5 && !!is_zorg_mail && FEATURES.ENABLE_ZORGMAIL && <RestrictedSettingsZorgMail />}
    </Box>
  </Page>;
}

